import React from 'react';

class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'oc'
  }
  render() {
    const {
      prefixCls,
    } = this.props;

    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-con`}>
          <h2>一、初始化</h2>
          <p>1、组件化开发是基于npm下使用<a href="http://facebook.github.io/react/" target="_blank">react</a>，所以必须先安装<a href="https://nodejs.org/en/" target="_blank">nodejs</a></p>
          <p>2、项目<a href="https://github.com/dyf2015/ReactjsES6" target="_blank">脚手架部署</a>进行开发环境初始化</p>
          <p>3、基于react的组件库有专门的事件机制，调用方式和传统方式类似，但兼容可以做到IE8+</p>
          <br />
          <h2>二、基础库</h2>
          <p>1、丰富的第三方组件库<a href="http://ant.design/docs/react/introduce" target="_blank">antd</a></p>
          <p>2、泛微组件库，有需要的找云商店admin</p>
          <br />
          <h2>三、调用方法</h2>
          <p>1、npm环境下调用，推荐此方法，模块化、组件化开发，提高复用率</p>
          <p>2、传统html上调用，此方法通常用于不做前端重构的应用开发</p>
          <br />
          <h2>四、泛微基础组件介绍</h2>
          <p>1、日期组件</p>
          <p>2、时间组件</p>
          <p>3、日期范围选择组件</p>
          <p>4、文本框组件</p>
          <p>5、数字框组件</p>
          <p>6、选择框组件</p>
          <p>7、多行文本组件</p>
          <p>8、树形组件</p>
          <p>9、栅格化组件</p>
          <p>10、布局组件</p>
          <p>...</p>
        </div>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/oc/componentDoc/Basic.js